export const API_URL="https://staging.sennrueti.ch:8000"
export const OIDC_URL="https://carsharing.sennrueti.ch/auth/realms"
